// extracted by mini-css-extract-plugin
module.exports = {"header":"SpotTravelInfoSummary_header__JvrXu","description":"SpotTravelInfoSummary_description__jyohR"};